import SitePreferences from './SitePreferences';

export default SitePreferences;
